import { useComputed } from '@preact/signals-react'
import { TFormFile } from '@/interfaces/form'
import { Row } from 'antd'

import SubsectionFileActions from './actions'
import { ApplicationsState, FormState } from '@/state'

import { filesAttached } from '.'

export default function SubsectionFileView({
  fileInfo,
}: {
  fileInfo: TFormFile
}) {
  const isView = ApplicationsState.viewMode.value.view

  const viewProps = useComputed(() => {
    const fileAttached = filesAttached.value.find(
      (item) => item.fileName === fileInfo.name
    )?.file

    return {
      fileAttached,
      showMessage: Boolean(
        fileInfo.required &&
          FormState.hasRequiredFieldsEmpty.value &&
          !fileAttached
      ),
    }
  })

  if (isView && !viewProps.value.fileAttached) return null

  return (
    <Row className='file-details'>
      <div className='file-info'>
        {fileInfo.required && <div className='file-required'>*</div>}
        <div className='file-description'>
          <div className='file-name'>{fileInfo.description}</div>
          {viewProps.value.showMessage && (
            <div className='file-required-message'>
              Este archivo es obligatorio
            </div>
          )}
        </div>
      </div>
      <SubsectionFileActions fileInfo={fileInfo} />
    </Row>
  )
}
